import Link from 'next/link'

import { Icon } from '~/components/atoms/Icon/Icon'
import Text, { TextSizes } from '~/components/atoms/Text/Text'
import { formatRating } from '~/services/formatRating'

import appReviews from '~~/appGoogleReviews.json'

import styles from './GoogleInlineReview.module.css'

export default function GoogleInlineReview() {
  return (
    <div className={styles.reviewSection}>
      <Icon type="GoogleColour" />
      <div className={styles.reviewStars}>
        <Text
          size={TextSizes.primaryTitleMed}
          className={styles.reviewStarsText}
          Tag="p"
        >
          {formatRating(appReviews?.averageRating)}
        </Text>
        <div className={styles.reviewStarsWrapper}>
          <Icon type="Star" />
          <Icon type="Star" />
          <Icon type="Star" />
          <Icon type="Star" />
          <Icon type="Star" />
        </div>
      </div>
      <Link
        href={
          'https://www.google.com/search?q=myartbroker&rlz=1C5CHFA_enGB854GB854&oq=myartbroker#lrd=0x4876052982786c7d:0x682f1d5656d65b0a,1,,,&mpd=~7552457469071855189/customers/reviews'
        }
        className={styles.reviewTotalLink}
        target="_blank"
      >
        <Text size={TextSizes.bodyMed} className={styles.reviewText} Tag="p">
          {appReviews?.totalReviewCount} Google Reviews
        </Text>
      </Link>
    </div>
  )
}
